import { render, staticRenderFns } from "./tempSetting.vue?vue&type=template&id=6a2f83b8&scoped=true"
import script from "./tempSetting.vue?vue&type=script&lang=js"
export * from "./tempSetting.vue?vue&type=script&lang=js"
import style0 from "./tempSetting.vue?vue&type=style&index=0&id=6a2f83b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2f83b8",
  null
  
)

export default component.exports